import { Box, Container, Fade, Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import Logo from "../theme/Logo";
import HomePageBody from "./HomePageBody";

const HomeWhiteLabel: React.FC = () => {
    const theme = useTheme();

    return (
        <Box>
            {/* Hero: gradient + Logo (no image) */}
            <Box
                sx={{
                    py: "5%",
                    minHeight: "calc(100vh - 200px)",
                    position: "relative",
                    background: `linear-gradient(135deg, 
                        ${theme.palette.primary.light}15 0%, 
                        ${theme.palette.secondary.light}15 50%, 
                        ${theme.palette.background.default} 100%)`,
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: `
                            radial-gradient(circle at 20% 50%, ${theme.palette.primary.main}10 0%, transparent 50%),
                            radial-gradient(circle at 80% 20%, ${theme.palette.secondary.main}10 0%, transparent 50%),
                            radial-gradient(circle at 40% 80%, ${theme.palette.primary.main}05 0%, transparent 50%)
                        `,
                        zIndex: 1
                    }}
                />
                <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Fade in timeout={1000}>
                                <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
                                    <Typography
                                        variant="h2"
                                        component="h1"
                                        sx={{
                                            fontSize: { xs: "2.5rem", md: "3.5rem" },
                                            fontWeight: "bold",
                                            mb: 2,
                                            background: `linear-gradient(45deg, ${theme.palette.secondary.light}, ${theme.palette.secondary.main}, ${theme.palette.secondary.dark})`,
                                            backgroundClip: "text",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent"
                                        }}
                                    >
                                        Confidence Isn't a Trait. It's a System.
                                    </Typography>
                                    <Typography
                                        variant="h5"
                                        component="h2"
                                        sx={{
                                            color: "text.secondary",
                                            mb: 3,
                                            lineHeight: 1.4
                                        }}
                                    >
                                        Strong Mind Strong Performance is a mental strengthening program designed for youth athletes ages 13–18. Our proven system transforms anxiety into confidence and inconsistency into peak performance.
                                    </Typography>
                                </Box>
                            </Fade>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Fade in timeout={1500}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        position: "relative"
                                    }}
                                >
                                    <Box sx={{ mb: 4 }}>
                                        <Logo height={400} />
                                    </Box>
                                </Box>
                            </Fade>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <HomePageBody />
        </Box>
    );
};

export default HomeWhiteLabel;
